/**
 * @file variantFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 26, 2023 07:53
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { objectExists, objectKeyExists, stringExists } from 'src/@common/utilities';

import {
    variantNewDialogSet,
} from '../../../actions/variant/variantPages.actions';

import {
    VARIANT_FIND_REQUEST,
    variantFindSuccess,
    variantFindFailure,
} from '../../../actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/find';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            variantId: payload.variantId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (resp.payload.errorExists && stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(variantFindSuccess(resp.payload));

        if (objectExists(resp.payload) &&
            objectKeyExists(resp.payload, 'variant') &&
            objectExists(resp.payload.variant)) {

            // close the variantNew diaglog, if open
            yield put(variantNewDialogSet(false));

            // if (action.payload.navigate) {
            //     // navigate to the edit page
            //     const variantId = resp.payload.variant._id;
            //     const targetPath = `/variant/edit/${variantId}`;

            //     return action.payload.navigate(targetPath);
            // }

        }

    } catch (error) {
        yield put(variantFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }


}

export default function* requestMonitor() {
    yield takeLatest(VARIANT_FIND_REQUEST, requestSaga);
}
